module.exports = __webpack_public_path__ + "img/step7(2).290fb08f.png";